function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { Drawer, Divider, Button, List, notification, Tag, Space, QRCode } from "antd";
import Common from "../components/includes/Common";
import AddEmployee from "../components/forms/AddEmployee";
import { PersonFillAdd, BoxFill, PersonFill, PersonVcardFill, TelephoneFill, PrinterFill, PencilSquare, QrCodeScan } from "react-bootstrap-icons";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import EditEmployee from "../components/forms/EditEmployee";
import Card from "../components/Card";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Hr = function Hr() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    depList = _useState2[0],
    setDepList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataChanged = _useState6[0],
    setIsDataChanged = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showNewEmployee = _useState0[0],
    setShowNewEmployee = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    employees = _useState10[0],
    setEmployees = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showPrint = _useState12[0],
    setShowPrint = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showEdit = _useState14[0],
    setShowEdit = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedItem = _useState16[0],
    setSelectedItem = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showQrCode = _useState18[0],
    setShowQrCode = _useState18[1];
  var ref = useRef();
  var ref2 = useRef();
  useEffect(function () {
    setDepList([]);
    axios.get("".concat(Common.baseApiUrl, "getdepartments")).then(function (response) {
      if (response.data.status == 200) {
        setDepList(response.data.departments);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue. code: " + error.toString());
    })["finally"](function () {
      setIsDataChanged(false);
    });
  }, []);
  useEffect(function () {
    axios.get("".concat(Common.baseApiUrl, "getemployees/").concat(Common.currentUser.id)).then(function (response) {
      setEmployees([]);
      if (response.data.status == 200) {
        setEmployees(response.data.employees);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue. code: " + error.toString());
    })["finally"](function () {
      setIsDataChanged(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          lg: 4,
          md: 4,
          children: [/*#__PURE__*/_jsx(Button, {
            type: "link",
            onClick: function onClick() {
              setShowNewEmployee(true);
            },
            children: /*#__PURE__*/_jsxs("b", {
              children: [/*#__PURE__*/_jsx(PersonFillAdd, {
                size: 20
              }), " AJOUTER UN(E) EMPLOYE(E)"]
            })
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
            children: depList.length > 0 && depList.map(function (d) {
              return /*#__PURE__*/_jsx(Col, {
                lg: 12,
                md: 12,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    border: "2px solid #F3F2EE",
                    padding: "15px",
                    borderRadius: "9px",
                    textAlign: "center",
                    background: "#FFFFFF"
                  },
                  children: [/*#__PURE__*/_jsx("h6", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: d.label
                    })
                  }), /*#__PURE__*/_jsxs("span", {
                    children: [d.employees.length, " employ\xE9(e)s"]
                  })]
                })
              }, d.id);
            })
          })]
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 7,
            offset: 1
          },
          md: {
            span: 7,
            offset: 1
          },
          children: /*#__PURE__*/_jsx(List, {
            dataSource: employees,
            itemLayout: "horizontal",
            renderItem: function renderItem(item, index) {
              return /*#__PURE__*/_jsx(List.Item, {
                actions: [/*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setSelectedItem(item);
                    setShowEdit(true);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(PencilSquare, {
                      size: 20
                    })
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setSelectedItem(item);
                    setShowPrint(true);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(PersonVcardFill, {
                      size: 20
                    })
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setSelectedItem(item);
                    setShowQrCode(true);
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: /*#__PURE__*/_jsx(QrCodeScan, {
                      size: 20
                    })
                  })
                })],
                children: /*#__PURE__*/_jsx(List.Item.Meta, {
                  avatar: /*#__PURE__*/_jsx(PersonFill, {
                    size: 24
                  }),
                  title: /*#__PURE__*/_jsxs("b", {
                    children: [item.firstname, " ", item.lastname]
                  }),
                  description: /*#__PURE__*/_jsxs(Space, {
                    children: [/*#__PURE__*/_jsxs("span", {
                      children: [/*#__PURE__*/_jsxs("b", {
                        children: [/*#__PURE__*/_jsx(TelephoneFill, {
                          size: 20
                        }), " "]
                      }), item.mobile]
                    }), " ", /*#__PURE__*/_jsx(Tag, {
                      color: "#f50",
                      children: item.department.label
                    })]
                  })
                })
              });
            }
          })
        })]
      })
    }), showNewEmployee && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "AJOUTER UN(E) EMPLOYE(E)"
        }),
        width: "370px",
        destroyOnClose: true,
        open: showNewEmployee,
        onClose: function onClose() {
          setShowNewEmployee(true);
        },
        children: /*#__PURE__*/_jsx(AddEmployee, {
          handler: function handler() {
            setIsDataChanged(true);
            setShowNewEmployee(false);
            notification.success({
              message: 'Ok',
              description: "Opération enregistrée"
            });
          }
        })
      })
    }), selectedItem != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER UN(E) EMPLOYE(E)"
        }),
        width: "370px",
        destroyOnClose: true,
        open: showEdit,
        onClose: function onClose() {
          setShowEdit(true);
        },
        children: /*#__PURE__*/_jsx(EditEmployee, {
          employee: selectedItem,
          handler: function handler() {
            setIsDataChanged(true);
            setShowEdit(false);
            notification.success({
              message: 'Ok',
              description: "Opération enregistrée"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "CARTE VITALE"
        }),
        width: "60%",
        open: showPrint,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref) {
                var handlePrint = _ref.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  size: "large",
                  type: "primary",
                  onClick: handlePrint,
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(PrinterFill, {
                      size: 22
                    }), " IMPRIMER"]
                  })
                });
              }
            })
          })
        }),
        onClose: function onClose() {
          setShowPrint(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(Card, {
          ref: ref,
          candidat: selectedItem
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "ID"
        }),
        width: "290px",
        open: showQrCode,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref2.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref2) {
                var handlePrint = _ref2.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  size: "large",
                  type: "primary",
                  onClick: handlePrint,
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(PrinterFill, {
                      size: 22
                    }), " IMPRIMER"]
                  })
                });
              }
            })
          })
        }),
        onClose: function onClose() {
          setShowQrCode(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx("div", {
          ref: ref2,
          children: /*#__PURE__*/_jsx(QRCode, {
            color: "#2A7780",
            value: Common.baseUrl + "#/employeeinfo/" + selectedItem.id,
            size: 190
          })
        })
      })]
    })]
  });
};
export default Hr;